/* eslint-disable */
import createIcon from '../createIcon';

const IconUploadOutlined = createIcon({
  name: 'icon-upload-outlined',
  content: '<path d="M513.664 128L757.76 372.16l-45.248 45.248L545.088 249.92V704h-64V251.072l-168.128 168-45.248-45.184z"/><path d="M896 896h-64v-.32H192v.32h-64V640h64v191.68h640V640h64v256z"/>',
  width: 1024,
  height: 1024
});
export default IconUploadOutlined;
